import React, { Dispatch, FC } from 'react';

import { ColumnHeader } from './column-header';
import { IColumnSortingInfo, IHeaderGroup } from 'types/table';

import { TableHeaderStyled } from 'ui/table.styled';

interface IHeaderColumnProps {
  headerGroups: IHeaderGroup[];
  columnsSorting?: IColumnSortingInfo[];
  sortColumnData?: Dispatch<IColumnSortingInfo>;
}

export const TableHeader: FC<IHeaderColumnProps> = ({ headerGroups, ...rest }) => (
  <TableHeaderStyled className="table-header">
    {headerGroups.map((headerGroup) => (
      <div {...headerGroup.getHeaderGroupProps()}>
        {headerGroup.headers.map((column) => (
          <ColumnHeader key={column.id} column={column} {...rest} />
        ))}
      </div>
    ))}
  </TableHeaderStyled>
);
